import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Curaduría obsesiva",
    text: "Cada mini perfume es elegido a mano por su carácter y su historia olfativa. Nada llega a la vitrina por casualidad.",
  },
  {
    n: "02",
    title: "Formato viajero",
    text: "Fragancias en miniatura para llevar el lujo en el bolsillo, probar antes de comprometerte, o coleccionar sin límites.",
  },
  {
    n: "03",
    title: "Atención personal",
    text: "Cada pedido se coordina directamente por WhatsApp con Vir. Sin intermediarios, con el cuidado de una boutique real.",
  },
];

export default function Manifesto() {
  return (
    <section
      data-testid="manifesto-section"
      className="max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-36"
    >
      <Reveal>
        <span className="text-[11px] uppercase tracking-[0.3em] text-rose">
          El manifiesto
        </span>
        <h2 className="mt-4 font-serif font-light text-4xl md:text-6xl max-w-3xl leading-[1.05]">
          Lujo accesible, escrito en <span className="italic text-rose">tres capítulos</span>.
        </h2>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-3 gap-px bg-line border border-line">
        {CHAPTERS.map((c, i) => (
          <Reveal
            key={c.n}
            delay={i * 0.12}
            className="bg-cream p-8 md:p-10 flex flex-col min-h-[280px]"
          >
            <span className="font-display text-6xl md:text-7xl text-copper/50">{c.n}</span>
            <h3 className="font-serif text-2xl mt-auto">{c.title}</h3>
            <p className="text-taupe text-sm font-light leading-relaxed mt-3">{c.text}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
